/**
 * Reads the cart cookie from the client-side.
 */
export function getCartCookieOnClient() {
  try {
    const rawCheckoutId = document.cookie
      .split('; ')
      .find((row) => row.startsWith('checkoutId='));

    if (!rawCheckoutId) return undefined;

    const encodedValue = rawCheckoutId.split('=').slice(1).join('=');
    const checkoutId = decodeURIComponent(encodedValue);

    return checkoutId;
  } catch (error) {
    console.error('Error reading cart cookie:', error);
    return undefined;
  }
}

/**
 * Returns an array like: [{ key: 'ppid', value: '...' }] if the PPID is
 * available, otherwise an empty array.
 *
 * Must be used on the client side to retrieve the PPID from `window`.
 *
 * This used to also merge customAttributes out of an `lsa-query-string`
 * cookie. That cookie carries Leesa's prefix and arrived with the initial
 * scaffolding of this repo; nothing in Birch ever wrote it, and it is absent
 * from both the new app and the live site even when landing with tracking
 * query params. Removed in BL-499 rather than renamed, since renaming a cookie
 * no one sets only moves the dead code somewhere tidier.
 */
export const getPPIDAttributes = () => {
  const attributes = [];
  if (
    typeof window !== 'undefined' &&
    typeof window?.['_pp']?.ppid !== 'undefined'
  ) {
    attributes.push({ key: 'ppid', value: window?.['_pp']?.ppid });
  }

  return attributes;
};
